// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__jid0L","bannerWrap":"Banner_bannerWrap__yOzJJ"};